import React, { useEffect, useState } from "react";

const SPLASH_DESKTOP =
  "https://customer-assets.emergentagent.com/job_alaca-partners/artifacts/8l0sljwz_a%C3%A7%C4%B1l%C4%B1%C5%9F.jpeg";
const SPLASH_MOBILE =
  "https://customer-assets.emergentagent.com/job_alaca-partners/artifacts/m3ay5gxg_mobil%20a%C3%A7%C4%B1l%C4%B1%C5%9F.jpeg";

export default function SplashScreen() {
  const [fadingOut, setFadingOut] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setFadingOut(true), 2500);
    return () => clearTimeout(t);
  }, []);

  return (
    <div
      data-testid="splash-screen"
      className="fixed inset-0 z-[100] bg-[#0F1A2E] transition-opacity duration-500 overflow-hidden"
      style={{ opacity: fadingOut ? 0 : 1, pointerEvents: fadingOut ? "none" : "auto" }}
      aria-hidden={fadingOut}
    >
      {/* Desktop / landscape splash */}
      <img
        src={SPLASH_DESKTOP}
        alt="Alaca Partners"
        className="absolute inset-0 w-full h-full object-cover select-none [@media(orientation:portrait)]:hidden"
        draggable="false"
      />
      {/* Mobile / portrait splash (square but composed for portrait crop) */}
      <img
        src={SPLASH_MOBILE}
        alt="Alaca Partners"
        className="absolute inset-0 w-full h-full object-cover select-none hidden [@media(orientation:portrait)]:block"
        draggable="false"
      />
    </div>
  );
}
